import {
  AccountState as LicenseState,
  LicenseCode,
  HttpAccountFilters,
} from '@account-users/account/models';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import { LicenseV2 } from '../../models/License';

export enum LicenseActionTypes {
  GetLicenses = '[Feature Toggle Licenses] Get Licenses',
  GetLicensesSuccess = '[Feature Toggle Licenses] Get Licenses Success',

  AddLicense = '[Feature Toggle Licenses] Add License',
  AddLicenseSuccess = '[Feature Toggle Licenses] Add License Success',

  UpdateLicense = '[Feature Toggle Licenses] Update License',
  UpdateLicenseStatus = '[Feature Toggle Licenses] Update License Status',
  UpdateLicenseSuccess = '[Fetaure Toggle Licenses] Update License',

  RemoveLicense = '[Feature Toggle Licenses] Remove License',
  RemoveLicenseSuccess = '[Feature Toggle License] Remove License Success',

  Failure = '[Feature Toggle Licenses] Failure',
}

export namespace LicenseActions {
  export namespace GetLicenses {
    export const request = createAction(
      LicenseActionTypes.GetLicenses,
      props<{ accountId: string; filters?: HttpAccountFilters }>(),
    );
    export const success = createAction(
      LicenseActionTypes.GetLicensesSuccess,
      props<{ items: LicenseV2[] }>(),
    );
  }

  export namespace AddLicense {
    export const request = createAction(
      LicenseActionTypes.AddLicense,
      props<{ accountId: string; licenseCode: LicenseCode }>(),
    );
    export const success = createAction(
      LicenseActionTypes.AddLicenseSuccess,
      props<{ update: Update<LicenseV2> }>(),
    );
  }

  export namespace UpdateLicense {
    export const request = createAction(
      LicenseActionTypes.UpdateLicense,
      props<{
        accountId: string;
        licenses: { licenseCode: LicenseCode; state?: LicenseState }[];
      }>(),
    );
    export const status = createAction(
      LicenseActionTypes.UpdateLicenseStatus,
      props<{ accountId: string; licenses: LicenseCode[] }>(),
    );
    export const success = createAction(
      LicenseActionTypes.UpdateLicenseSuccess,
      props<{ updates: Update<LicenseV2>[] }>(),
    );
  }

  export namespace RemoveLicense {
    export const request = createAction(
      LicenseActionTypes.RemoveLicense,
      props<{ accountId: string; licenseCode: LicenseCode }>(),
    );
    export const success = createAction(
      LicenseActionTypes.RemoveLicenseSuccess,
      props<{ licenseCode: LicenseCode }>(),
    );
  }

  export const failure = createAction(
    LicenseActionTypes.Failure,
    props<{ errorMessage: string }>(),
  );
}
